import { WarningDialog } from "src/components/warning-dialog";

import { RootState } from "src/store";
import { connect } from "react-redux";
import { hasValue } from "@itk/typescript-utils";
import { applicationActions } from "../../../application-store";
import { DocumentViewerDialog } from "src/components/document-viewer/document-viewer-dialog";

const mapStateToProps = (state: RootState) => ({
  ...state.generalReducer.applicationReducer
});

const ownActions = {
  ...applicationActions
};

type Props = ReturnType<typeof mapStateToProps> & typeof ownActions;

const GlobalDialogBase = (props: Props) => {
  const { warningAction, openFileModel, resetFile } = props;

  return (
    <>
      {hasValue(openFileModel) && <DocumentViewerDialog fileInfo={openFileModel} resetFile={resetFile} />}
      {hasValue(warningAction) && <WarningDialog warningAction={warningAction} />}
    </>
  );
};

export const GlobalDialog = connect(mapStateToProps, ownActions)(GlobalDialogBase);
